import { Box, Button, Typography } from '@mui/material';
import { replaceUrlLink } from '@utils';
import icon_mini_chat_close from '@images/icon_mini_chat_close.png';

const Disclaimer = ({ styles, t, handleDisclaimer, minichatUrl }) => {
  return (
    <Box sx={styles.disclaimerBox}>
      <Box sx={styles.disclaimerHeader}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={styles.headerTitle}>{t('4530_chat_common.disclaimer')}</Typography>
        </Box>
        <Button sx={{ padding: 0, minWidth: 0 }} onClick={handleDisclaimer}>
          <img style={{ width: '16px' }} src={icon_mini_chat_close} alt="icon_mini_chat_close" />
        </Button>
      </Box>

      <Box sx={styles.disclaimerBody}>
        <Typography sx={styles.disclamierTitle}>{t('4530_chat_common.safeguarding_your_data_in_the_hyundai_assistant')}</Typography>
        <Box sx={styles.disclamierTextBox}>
          <Typography sx={styles.disclamierTitle}>{t('4530_chat_common.how_we_process_your_data')}</Typography>
          <Typography sx={styles.disclamierText}>
            {replaceUrlLink(t('4530_chat_common.your_privacy_is_important_to_us'), t('4530_chat_common.data_privacy_policy'), minichatUrl, {
              linkText: styles.consentLink,
            })}
          </Typography>
          <Typography sx={styles.disclamierText}>
            {t('4530_chat_common.we_also_want_to_ensure_you_are_safeguarding_your_personal_information')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Disclaimer;
